import CONSTANTS from '../CONSTANTS';

export const actionSetLoading = loading => ({
  type: CONSTANTS.LOADING,
  loading
});
